/* Chai Break — shared UI behavior: toast, mobile nav, accordions, gallery, variant picker */

function showToast(message) {
  let toast = document.querySelector(".toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.className = "toast";
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add("show");
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove("show"), 3000);
}
window.showToast = showToast;

/* Formats an integer cents amount using the shop's money_format string (same convention as Shopify's own JS). */
function formatMoney(cents, format) {
  format = format || window.themeMoneyFormat || "${{amount}}";
  const value = (cents / 100).toFixed(2);
  const [whole, decimal] = value.split(".");
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const amount = `${withCommas}.${decimal}`;
  const amountNoDecimals = withCommas;
  return format
    .replace(/\{\{\s*amount\s*\}\}/, amount)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals);
}
window.formatMoney = formatMoney;

function initMobileNav() {
  const toggle = document.getElementById("mobileToggle");
  const menu = document.getElementById("mobileNav");
  if (!toggle || !menu) return;
  toggle.addEventListener("click", () => {
    const isOpen = menu.classList.toggle("open");
    toggle.setAttribute("aria-expanded", String(isOpen));
  });
}

function initAccordions() {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".accordion-item > button");
    if (!btn) return;
    const item = btn.closest(".accordion-item");
    const wasActive = item.classList.contains("active");
    item.parentElement.querySelectorAll(".accordion-item").forEach((el) => el.classList.remove("active"));
    if (!wasActive) item.classList.add("active");
  });
}

function initGalleryThumbs() {
  document.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    const main = document.getElementById("gallery-main");
    if (main) main.src = thumb.dataset.galleryThumb;
    document.querySelectorAll("[data-gallery-thumb]").forEach((t) => t.setAttribute("aria-current", String(t === thumb)));
  });
}

/* Product variant picker: reads embedded product JSON, matches selected options to a variant,
   updates price / availability / image / hidden variant id input without a page reload. */
function initVariantPicker(form) {
  const dataEl = form.querySelector("[data-product-json]");
  if (!dataEl) return;
  const product = JSON.parse(dataEl.textContent);
  const selected = {};

  form.querySelectorAll("[data-option-position]").forEach((btn) => {
    if (btn.getAttribute("aria-current") === "true") selected[btn.dataset.optionPosition] = btn.dataset.optionValue;
  });

  function findVariant() {
    return product.variants.find((v) =>
      (!selected["1"] || v.option1 === selected["1"]) &&
      (!selected["2"] || v.option2 === selected["2"]) &&
      (!selected["3"] || v.option3 === selected["3"])
    );
  }

  function update() {
    const variant = findVariant();
    const idInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector("[data-product-price]");
    const addBtn = form.querySelector("[data-add-to-bag]");
    const qtyInput = form.querySelector('[name="quantity"]');
    const colorLabel = form.querySelector("[data-selected-color]");
    const sizeLabel = form.querySelector("[data-selected-size]");
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (colorLabel && selected["1"]) colorLabel.textContent = selected["1"];
    if (sizeLabel && selected["2"]) sizeLabel.textContent = selected["2"];

    form.querySelectorAll("[data-option-position]").forEach((btn) => {
      btn.setAttribute("aria-current", String(selected[btn.dataset.optionPosition] === btn.dataset.optionValue));
    });

    if (variant) {
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.dataset.quickAddVariant = variant.id;
        addBtn.textContent = variant.available
          ? `${addBtn.dataset.addLabel || "ADD TO BAG"} — ${formatMoney(variant.price * qty)}`
          : "SOLD OUT";
      }
      if (variant.featured_image) {
        const mainImg = document.getElementById("gallery-main");
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    } else if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = "UNAVAILABLE";
    }
  }

  form.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-option-position]");
    if (!btn || btn.disabled) return;
    selected[btn.dataset.optionPosition] = btn.dataset.optionValue;
    update();
  });

  const qtyMinus = form.querySelector("#qty-minus");
  const qtyPlus = form.querySelector("#qty-plus");
  const qtyValue = form.querySelector("#qty-value");
  const qtyHidden = form.querySelector('[name="quantity"]');
  function setQty(n) {
    n = Math.max(1, Math.min(10, n));
    if (qtyValue) qtyValue.textContent = n;
    if (qtyHidden) qtyHidden.value = n;
    update();
  }
  if (qtyMinus) qtyMinus.addEventListener("click", () => setQty((parseInt(qtyHidden.value, 10) || 1) - 1));
  if (qtyPlus) qtyPlus.addEventListener("click", () => setQty((parseInt(qtyHidden.value, 10) || 1) + 1));

  update();
}

/* Product recommendations: Shopify only populates the `recommendations` object when a
   section is re-fetched through its recommendations endpoint, so we fetch it client-side
   and swap in the freshly rendered grid. */
function initProductRecommendations() {
  document.querySelectorAll("[data-recommendations-url]").forEach((wrapper) => {
    fetch(wrapper.dataset.recommendationsUrl)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const freshGrid = doc.querySelector("[data-recommendations-grid]");
        const currentGrid = wrapper.querySelector("[data-recommendations-grid]");
        if (freshGrid && currentGrid) currentGrid.innerHTML = freshGrid.innerHTML;
      })
      .catch(() => { /* recommendations are a progressive enhancement; fail silently */ });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initMobileNav();
  initAccordions();
  initGalleryThumbs();
  initProductRecommendations();
  document.querySelectorAll("form[data-product-form]").forEach(initVariantPicker);
});
